<div class="content-wrapper container-xxl p-0 card">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.daily_users' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Users
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text mr-1">{{ 'MENU.DASHBOARD.DAILY_USERS_LIST' | translate }}</p>
          </div>
        </div>
  
        <div class="row d-flex justify-content-between">
           <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group">
              <label for="itemsPerPage" class="mr-2">{{ 'MENU.DASHBOARD.SHOW' | translate }}</label>
              <div class="d-flex align-items-center">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm mr-2"
                  [(ngModel)]="itemsPerPage"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span class="mr-1">{{ 'MENU.DASHBOARD.ENTRIES' | translate }}</span>
              </div>
            </div>
          </div> 
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="">{{ 'MENU.DASHBOARD.SEARCH' | translate }}</label>
              <input
                id="searchInput"
                type="search"
                placeholder="{{ 'MENU.DASHBOARD.SEARCH' | translate }}"
                class="form-control form-control-sm w-75"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div>
        </div>
  
        <ngx-datatable
          [rows]="arrCoupons" 
          [rowHeight]="58"
          class="bootstrap core-bootstrap bg-white"
          [limit]="itemsPerPage"
          [columnMode]="ColumnMode.force"
          [headerHeight]="40"
          [footerHeight]="50"
          [scrollbarH]="true"
                      [messages]="{ totalMessage: lang == 'ar' ? 'العدد الكلي' : 'total' }"

        >
          <ngx-datatable-column
            name="{{ 'MENU.DASHBOARD.ID' | translate }}"
            prop="id"
            [width]="100"
          ></ngx-datatable-column>

       

<!-- Name -->
<ngx-datatable-column
  name="{{ lang == 'ar' ? 'الاسم' : 'Name' }}"
  prop="name"
  [width]="200">
  <ng-template ngx-datatable-cell-template let-row="row">
    <strong>{{ row.name }}</strong>
  </ng-template>
</ngx-datatable-column>

<!-- Email -->
<ngx-datatable-column
  name="{{ lang == 'ar' ? 'البريد الإلكتروني' : 'Email' }}"
  prop="email"
  [width]="260">
</ngx-datatable-column>

<!-- Type -->
<ngx-datatable-column
  name="{{ lang == 'ar' ? 'النوع' : 'Type' }}"
  prop="type"
  [width]="120">
</ngx-datatable-column>

<!-- Country -->
<ngx-datatable-column
  name="{{ lang == 'ar' ? 'الدولة' : 'Country' }}"
  [width]="160">
  <ng-template ngx-datatable-cell-template let-row="row">
    {{ row.country || '-' }}
  </ng-template>
</ngx-datatable-column>

<!-- City -->
<ngx-datatable-column
  name="{{ lang == 'ar' ? 'المدينة' : 'City' }}"
  [width]="160">
  <ng-template ngx-datatable-cell-template let-row="row">
    {{ row.city || '-' }}
  </ng-template>
</ngx-datatable-column>

<!-- Last Login -->
<ngx-datatable-column
  name="{{ lang == 'ar' ? 'آخر تسجيل دخول' : 'Last Login' }}"
  [width]="220">
  <ng-template ngx-datatable-cell-template let-row="row">
    {{ row.last_login_at | date:'medium' }}
  </ng-template>
</ngx-datatable-column>

          <ngx-datatable-column
            name="{{ 'MENU.DASHBOARD.ACTIONS' | translate }}"
            [width]="100"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div ngbDropdown container="body">
                <button
                  type="button"
                  class="btn btn-sm hide-arrow"
                  ngbDropdownToggle
                >
                  <i data-feather="more-vertical"></i>
                </button>
                <div ngbDropdownMenu>

<!-- <a
  ngbDropdownItem
  [routerLink]="['/z-users-details', row.id]"
>
  <i  
    data-feather="eye"
    [class]="lang === 'ar' ? 'ml-3' : 'mr-3'"
  ></i>
  <span>{{ "MENU.DASHBOARD.Details" | translate }}</span>
</a> -->

  <!-- <a
                      ngbDropdownItem
                      (click)="deleteUser(row.id)"
                      class="text-danger"
                    >
                      <i data-feather="x-octagon" [class]="lang == 'ar' ? 'ml-1' : 'mr-1'"></i
                      ><span>{{ "MENU.DASHBOARD.closeAcc" | translate }}</span>
                    </a> -->
                  <a
                    ngbDropdownItem
                    [routerLink]="['/edit-DAILY_USERS', row.id]"
                  >
                    <i data-feather="edit-2"   [class]="lang === 'ar' ? 'ml-3' : 'mr-3'"></i
                    ><span>{{ "MENU.DASHBOARD.EDIT" | translate }}</span>
                  </a>
                  <a ngbDropdownItem (click)="confirmDelete(row.id)">
                    <i data-feather="trash"   [class]="lang === 'ar' ? 'ml-3' : 'mr-3'"></i
                    ><span>{{ "MENU.DASHBOARD.DELETE" | translate }}</span>
                  </a>
                </div>
              </div> 
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable> 
      </section>
    </div>
  </div>
  


  <!-- Message Modal -->
<div
  class="modal fade"
  id="messageModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">
          {{ lang === 'ar' ? 'الرسالة' : 'Message' }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">
        <p class="mb-0" style="white-space: pre-line;">
          {{ selectedMessage }}
        </p>
      </div>

    </div>
  </div>
</div>
